import { render, staticRenderFns } from "./thridShop.vue?vue&type=template&id=4bbf79e6"
import script from "./thridShop.vue?vue&type=script&route=%2Fset_up_shop%2Fthrid_shop&lang=js"
export * from "./thridShop.vue?vue&type=script&route=%2Fset_up_shop%2Fthrid_shop&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports